module.exports = __webpack_public_path__ + "img/slotmachine.3b53fe45.png";